import { render, staticRenderFns } from "./SyllabusForm.vue?vue&type=template&id=78616bdc&"
import script from "./SyllabusForm.vue?vue&type=script&lang=js&"
export * from "./SyllabusForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports